import { useEffect } from 'react';

const useResponsivePrivacyButton = () => {
  useEffect(() => {
    const updateButton = () => {
      const isSmall = window.innerWidth <= 1200;

      const findInShadowDOM = (element) => {
        if (element.shadowRoot) {
          const btn = element.shadowRoot.querySelector(
            '[aria-label="Open Privacy Settings"][data-testid="uc-privacy-button"]'
          );
          if (btn) {
            // Update button styles - minimum legal compliance sizes
            if (isSmall) {
              // Small: 28px for consistency with other buttons
              btn.style.setProperty('padding', '0', 'important');
              btn.style.setProperty('width', '28px', 'important');
              btn.style.setProperty('height', '28px', 'important');
              btn.style.bottom = '4px';
              btn.style.left = '4px';
            } else {
              // Large: 44px minimum for WCAG 2.2 Level AAA compliance (recommended for critical buttons)
              btn.style.setProperty('padding', '0', 'important');
              btn.style.setProperty('width', '44px', 'important');
              btn.style.setProperty('height', '44px', 'important');
              btn.style.bottom = '18px';
              btn.style.left = '18px';
            }

            // Update div inside button - this creates the button size
            const div = btn.querySelector('[data-testid="uc-privacy-icon"]');
            if (div) {
              if (isSmall) {
                div.style.setProperty('padding', '4px', 'important');
                div.style.setProperty('width', '28px', 'important');
                div.style.setProperty('height', '28px', 'important');
              } else {
                div.style.setProperty('padding', '6px', 'important');
                div.style.setProperty('width', '44px', 'important');
                div.style.setProperty('height', '44px', 'important');
              }
            }

            // Update SVG
            const svg = btn.querySelector('svg');
            if (svg) {
              const size = isSmall ? '20' : '32';
              svg.setAttribute('width', size);
              svg.setAttribute('height', size);
            }
            return true;
          }
        }

        for (const child of element.children || []) {
          if (findInShadowDOM(child)) return true;
        }

        return false;
      };

      findInShadowDOM(document.body);
    };

    updateButton();

    window.addEventListener('resize', updateButton);

    const observer = new MutationObserver(updateButton);
    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      window.removeEventListener('resize', updateButton);
      observer.disconnect();
    };
  }, []);
};

export default useResponsivePrivacyButton;
